import React from 'react';
export const Title = () => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, "Wait a second!", /*#__PURE__*/React.createElement("br", null), "You\u2019ve uploaded a non-vector art file.", /*#__PURE__*/React.createElement("br", null));
};